import { uniqueArrayObj } from "shared/utilities";

export const getAllEntityMembers = (row) => {
  if (!row) return [];
  const company_boards = uniqueArrayObj(
    row.company_board_members,
    "company_id"
  ).map((member) => ({
    link: `/companies/${member.company_id}`,
    name: member.company_name,
    seat_name: member.seat_name,
    institution_type: "Listed",
    market_capital: member.company_market_capital,
    class: "ps-board",
    remuneration: member.remuneration,
    time_on_board_in_ms: member.time_on_board_in_ms,
    start_date: member.start_date,
    end_date: member.end_date,
  }));

  const company_exec = uniqueArrayObj(
    row.company_csuite_members,
    "company_id"
  ).map((member) => ({
    link: `/companies-with-executives/${member.company_id}`,
    name: member.company_name,
    seat_name: member.seat_name,
    institution_type: "Listed",
    market_capital: member.company_market_capital,
    class: "ps-executive",
    remuneration: member.remuneration,
    time_on_board_in_ms: member.time_on_board_in_ms,
    start_date: member.start_date,
    end_date: member.end_date,
  }));

  const private_company_boards = uniqueArrayObj(
    row.private_company_board_members,
    "private_company_id"
  ).map((member) => ({
    link: `/private-companies/${member.private_company_id}`,
    name: member.company_name,
    seat_name: member.seat_name,
    institution_type: "Private",
    market_capital: 0,
    class: "ps-board",
    remuneration: member.remuneration,
    time_on_board_in_ms: member.time_on_board_in_ms,
    start_date: member.start_date,
    end_date: member.end_date,
    hidden: member.hidden,
  }));

  const private_company_exec = uniqueArrayObj(
    row.private_company_csuite_members,
    "private_company_id"
  ).map((member) => ({
    link: `/private-companies-with-executives/${member.private_company_id}`,
    name: member.company_name,
    seat_name: member.seat_name,
    institution_type: "Private",
    market_capital: 0,
    class: "ps-executive",
    remuneration: member.remuneration,
    time_on_board_in_ms: member.time_on_board_in_ms,
    start_date: member.start_date,
    end_date: member.end_date,
    hidden: member.hidden,
  }));

  const super_boards = uniqueArrayObj(
    row.superannuation_board_members,
    "superannuation_id"
  ).map((member) => ({
    link: `/superannuations/${member.superannuation_id}`,
    name: member.company_name,
    seat_name: member.seat_name,
    institution_type: "Super",
    market_capital: 0,
    class: "ps-board",
    remuneration: member.remuneration,
    time_on_board_in_ms: member.time_on_board_in_ms,
    start_date: member.start_date,
    end_date: member.end_date,
  }));

  const super_exec = uniqueArrayObj(
    row.superannuation_csuite_members,
    "superannuation_id"
  ).map((member) => ({
    link: `/superannuations-with-executives/${member.superannuation_id}`,
    name: member.company_name,
    seat_name: member.seat_name,
    institution_type: "Super",
    market_capital: 0,
    class: "ps-executive",
    remuneration: member.remuneration,
    time_on_board_in_ms: member.time_on_board_in_ms,
    start_date: member.start_date,
    end_date: member.end_date,
  }));

  const government_boards = uniqueArrayObj(
    row.government_board_members,
    "government_id"
  ).map((member) => ({
    link: `/governments/${member.government_id}`,
    name: member.company_name,
    seat_name: member.seat_name,
    institution_type: "Govt",
    market_capital: 0,
    class: "ps-board",
    remuneration: member.remuneration,
    time_on_board_in_ms: member.time_on_board_in_ms,
    start_date: member.start_date,
    end_date: member.end_date,
  }));

  const government_exec = uniqueArrayObj(
    row.government_csuite_members,
    "government_id"
  ).map((member) => ({
    link: `/governments-with-executives/${member.government_id}`,
    name: member.company_name,
    seat_name: member.seat_name,
    institution_type: "Govt",
    market_capital: 0,
    class: "ps-executive",
    remuneration: member.remuneration,
    time_on_board_in_ms: member.time_on_board_in_ms,
    start_date: member.start_date,
    end_date: member.end_date,
  }));

  const other_government_boards = uniqueArrayObj(
    row.other_government_board_members,
    "other_government_id"
  ).map((member) => ({
    link: `/minor-governments/${member.other_government_id}`,
    name: member.company_name,
    seat_name: member.seat_name,
    institution_type: "Other Govt",
    market_capital: 0,
    class: "ps-board",
    remuneration: member.remuneration,
    time_on_board_in_ms: member.time_on_board_in_ms,
    start_date: member.start_date,
    end_date: member.end_date,
  }));

  const other_government_exec = uniqueArrayObj(
    row.other_government_csuite_members,
    "other_government_id"
  ).map((member) => ({
    link: `/minor-governments-with-executives/${member.other_government_id}`,
    name: member.company_name,
    seat_name: member.seat_name,
    institution_type: "Other Govt",
    market_capital: 0,
    class: "ps-executive",
    remuneration: member.remuneration,
    time_on_board_in_ms: member.time_on_board_in_ms,
    start_date: member.start_date,
    end_date: member.end_date,
  }));

  const nfp_boards = uniqueArrayObj(row.nfp_board_members, "nfp_id").map(
    (member) => ({
      link: `/nfps/${member.nfp_id}`,
      name: member.company_name,
      seat_name: member.seat_name,
      institution_type: "Not for Profit",
      market_capital: 0,
      class: "ps-board",
      remuneration: member.remuneration,
      time_on_board_in_ms: member.time_on_board_in_ms,
      start_date: member.start_date,
      end_date: member.end_date,
    })
  );

  const nfp_exec = uniqueArrayObj(row.nfp_csuite_members, "nfp_id").map(
    (member) => ({
      link: `/nfps-with-executives/${member.nfp_id}`,
      name: member.company_name,
      seat_name: member.seat_name,
      institution_type: "Not for Profit",
      market_capital: 0,
      class: "ps-executive",
      remuneration: member.remuneration,
      time_on_board_in_ms: member.time_on_board_in_ms,
      start_date: member.start_date,
      end_date: member.end_date,
    })
  );

  return [
    ...company_boards,
    ...company_exec,
    ...private_company_boards,
    ...private_company_exec,
    ...super_boards,
    ...super_exec,
    ...government_boards,
    ...government_exec,
    ...other_government_boards,
    ...other_government_exec,
    ...nfp_boards,
    ...nfp_exec,
  ];
};

// Placeholder for plan checking utilities (from legacy Search.jsx)
export const isProfilePlan = (currentUser) =>
  currentUser && currentUser.plan === "profile";
export const isIndividualPlan = (currentUser) =>
  currentUser && currentUser.plan === "individual";
export const isInstitutionalPlan = (currentUser) =>
  currentUser && currentUser.plan === "institutional";

export const formatDuration = (ms) => {
  if (ms === null || ms === undefined) return "N/A";
  const seconds = Math.floor((ms / 1000) % 60);
  const minutes = Math.floor((ms / (1000 * 60)) % 60);
  const hours = Math.floor((ms / (1000 * 60 * 60)) % 24);
  const days = Math.floor((ms / (1000 * 60 * 60 * 24)) % 30); // Approx
  const months = Math.floor((ms / (1000 * 60 * 60 * 24 * 30)) % 12); // Approx
  const years = Math.floor(ms / (1000 * 60 * 60 * 24 * 365)); // Approx

  if (years > 0) return `${years}y ${months}m`;
  if (months > 0) return `${months}m ${days}d`;
  if (days > 0) return `${days}d ${hours}h`;
  if (hours > 0) return `${hours}h ${minutes}m`;
  return `${minutes}m ${seconds}s`;
};

export const printReport = (
  templateId,
  fileName,
  data,
  startCb,
  doneCb,
  email
) => {
  if (startCb) startCb();
  // Simulate report generation
  setTimeout(() => {
    if (doneCb) doneCb();
    alert("Report generation simulated.");
  }, 2000);
};
export const getDisplayableMemberships = (allMembers, sort = true) => {
  if (!allMembers || allMembers.length === 0) return [];

  if (!sort) return allMembers;

  // Prioritize current directorships/exec roles, then past ones
  // Further sort by significance if possible (e.g., market cap, though not directly available on all members)
  return [...allMembers].sort((a, b) => {
    const aIsCurrent = !a.end_date || new Date(a.end_date) > new Date();
    const bIsCurrent = !b.end_date || new Date(b.end_date) > new Date();

    if (aIsCurrent && !bIsCurrent) return -1;
    if (!aIsCurrent && bIsCurrent) return 1;

    // Basic sort by name if both are current or both past
    return (a.name || "").localeCompare(b.name || "");
  });
};

export const formatSimpleDate = (dateString) => {
  if (!dateString || dateString === "N/A") return "N/A";
  try {
    const date = new Date(dateString);
    // Check if date is valid
    if (isNaN(date.getTime())) {
      // Try to parse "DD MMM YYYY" format if initial parsing fails or if it's already in a good string format
      const parts = dateString.match(/(\d{1,2}) (\w{3}) (\d{4})/);
      if (parts) return dateString; // Assume it's already formatted if it matches
      return "N/A";
    }
    return date.toLocaleDateString("en-AU", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  } catch (e) {
    return dateString; // Return original if parsing fails, or "N/A"
  }
};

export const toCurrency = (amount) => {
  if (!amount || amount === "N/A" || amount === 0 || amount === null)
    return undefined;
  const numAmount = Number.parseFloat(amount);
  if (isNaN(numAmount) || numAmount === 0) return null;
  return new Intl.NumberFormat("en-AU", {
    style: "currency",
    currency: "AUD",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(numAmount);
};

export const formatMarketCap = (marketCap) => {
  if (
    !marketCap ||
    marketCap === "N/A" ||
    marketCap === 0 ||
    marketCap === null
  )
    return null;
  const value = Number.parseFloat(marketCap);
  if (isNaN(value) || value === 0) return null;
  if (value >= 1e9) {
    return `$${(value / 1e9).toFixed(1)}B`;
  } else if (value >= 1e6) {
    return `$${(value / 1e6).toFixed(1)}M`;
  }
  return toCurrency(value);
};
